module.exports = __webpack_public_path__ + "static/img/4-4.69d2a2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/4-4.png
// module id = pwmZ
// module chunks = 0